// @ts-nocheck
import { useRole } from "@/contexts/RoleContext";
import { useMyOrganization } from "@/hooks/useMyOrganization";
import { useOrganization } from "@/hooks/useOrganization";

/**
 * Resolves the org scoping rules for the shared admin dashboard.
 *
 *  - Platform / super admin  -> scopeOrgId = null  (NO org filter, sees ALL orgs)
 *  - Org admin / tenant admin -> scopeOrgId = their membership org id
 *
 * `createOrgId` is the org id to stamp on NEW rows:
 *  - org admin -> their own org
 *  - super admin -> the host/white-label org (so platform-created rows still
 *    land on a valid org instead of null)
 *
 * Always gate queries on `ready` so we don't fire an unscoped query for an org
 * admin before their membership org has loaded (which would leak other orgs).
 */
export function useAdminOrgScope() {
  const { isSuperAdmin, loading: roleLoading } = useRole();
  const { organization: myOrg, isLoading: myOrgLoading } = useMyOrganization();
  const { organization: hostOrg } = useOrganization();

  const scopeOrgId = isSuperAdmin ? null : myOrg?.id ?? null;
  const createOrgId = isSuperAdmin ? hostOrg?.id ?? null : myOrg?.id ?? null;

  // Super admins are ready as soon as roles resolve; org admins must wait for
  // their membership org so we never run an unfiltered query for them.
  const loading = roleLoading || (!isSuperAdmin && myOrgLoading);
  const ready = !loading && (isSuperAdmin || !!scopeOrgId);

  return { scopeOrgId, createOrgId, isSuperAdmin, loading, ready };
}
